module.exports = __webpack_public_path__ + "static/media/login_button.ea5fa639.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OnboardingRedesign/login_button.svg
// module id = 2247
// module chunks = 0